import {InjectionToken} from '@angular/core';

export interface AuthConfiguration {
    gateway: string;
    API_URL: string;
    oauth2_issuer: string;
    tenant_alias: string;
    e2e?: boolean;

    /**
     * Fallback E2E access token, used ONLY when {@link e2e} is true and no
     * `e2e_access_token` is present in localStorage.
     *
     * The E2E runners set that localStorage entry themselves, so they keep working unchanged and
     * keep precedence. This field exists for environments a HUMAN opens in a browser — without it
     * the first request of every fresh browser profile goes out with an empty token and fails 401,
     * with nothing on screen explaining why.
     */
    e2e_access_token?: string;

    /**
     * Tenant logo URLs configured in the shell environment, used as a FALLBACK whenever the
     * tenant info that reaches {@link TenantService} carries no logo.
     *
     * Two paths leave the tenant without a logo today: the e2e auth bypass builds its tenant
     * info locally (no gateway call, no branding), and a local shell talking to the gateway
     * gets "Tenant not found" because the gateway resolves the tenant from the request host.
     * The URLs already exist in every environment file — without these fields nothing reads
     * them, so the top bar renders an empty <img>.
     *
     * Values served by the gateway always take precedence.
     */
    tenant_logoColorBright?: string;
    tenant_logoColorDark?: string;
    tenant_logoBright?: string;
    tenant_logoDark?: string;
}

export const AUTH_CONFIG = new InjectionToken<AuthConfiguration>('auth.config');